import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Row, Col, Image, Form, Button, Alert } from 'react-bootstrap'
import SweetAlert from 'react-bootstrap-sweetalert'
import Card from '../../../components/Card'
import axios from 'axios'

// assets
import auth5 from '../../../assets/images/auth/05.png'

const ResetPassword = () => {
  const navigate = useNavigate()
  const { token } = useParams()
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [message, setMessage] = useState("")
  const [variant, setVariant] = useState("success")
  const [showUpdateSuccess, setShowUpdateSuccess] = useState(false)
  const [showUpdateFailed, setShowUpdateFailed] = useState(false)

  useEffect(() => {
  const validateToken = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL_REGISTER}/reset-password/${token}`);
      console.log("✅ Token valid:", res.data);
    } catch (err) {
      console.error("❌ Token tidak valid:", err.response?.data);
      navigate("/404"); 
    }
  };

  if (token) validateToken();
}, [token]);


const handleSubmit = async (e) => {
  e.preventDefault()

  if (newPassword !== confirmPassword) {
    setMessage("Konfirmasi password tidak sama!")
    setVariant("danger")
    setShowUpdateFailed(true)
    return
  }

 try {
  const res = await axios.post(`${process.env.REACT_APP_API_URL_REGISTER}/reset-password`, {
    token,
    newPassword
  })

  console.log("✅ Respon sukses:", res.data)

  setMessage(res.data.message)
  setVariant("success")
  setShowUpdateSuccess(true)
} catch (err) {
  console.log("❌ Gagal:", err.response?.data)
  setMessage(err.response?.data?.message || "Gagal reset password.")
  setVariant("danger")
  setShowUpdateFailed(true)
}

}


  return (
    <>
      <section className="login-content">
        <Row className="m-0 align-items-center bg-white vh-100">
          <div className="col-md-6 d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden">
            <Image src={auth5} className="Image-fluid gradient-main animated-scaleX" alt="images" />
          </div>
          <Col md="6">
            <Row className="justify-content-center">
              <Col md="10">
                <Card className="card-transparent auth-card shadow-none d-flex justify-content-center mb-0">
                  <Card.Body>
                    <div className="container mt-5">
                      <h3>Reset Password</h3>
                      {message && <Alert variant={variant}>{message}</Alert>}
                      <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formNewPassword" className="mt-3">
                          <Form.Label>Password Baru</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Masukkan password baru"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                          />
                        </Form.Group>

                        <Form.Group controlId="formConfirmPassword" className="mt-3">
                          <Form.Label>Konfirmasi Password Baru</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Ulangi password baru"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                          />
                        </Form.Group>

                        <Button type="submit" className="mt-3" variant="primary">
                          Reset Password
                        </Button>
                      </Form>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>

      {showUpdateSuccess && (
        <SweetAlert
          title="Berhasil"
          success
          onConfirm={() => {
            setShowUpdateSuccess(false)
            navigate("/login")
          }}
          btnSize="sm"
        >
          Password Anda telah berhasil diubah.
        </SweetAlert>
      )}

      {showUpdateFailed && (
        <SweetAlert
          title="Gagal"
          danger
          onConfirm={() => setShowUpdateFailed(false)}
          btnSize="sm"
        >
          {message}
        </SweetAlert>
      )}
    </>
  )
}

export default ResetPassword
